import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { gql } from 'graphql-request'
import { GenericBlock } from '../generic'

export const landingPerksFragment = gql`
  fragment landingPerksFragment on LandingPerks {
    id
    title
    subtitle
    tiers {
      memberTier {
        id
        name
        slug
        planLevel
        memberfulPlans {
          memberfulPlan {
            id
            externalId
            type
            price
            savings
            smallPrint
          }
        }
      }
      displayName
      description
      id
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

type Frequency = 'monthly' | 'quarterly' | 'annually'

interface MemberfulPlan {
  id: string
  externalId: string
  type: Frequency
  price: number | string // Can be number (dollars) or string
  savings?: number
  smallPrint?: string
}

interface TierPerk {
  id: string
  perk: string
}

export interface LandingPerks extends GenericBlock<'LandingPerks'> {
  title?: string
  subtitle?: string
  tiers: {
    memberTier: {
      id: string
      name: string
      slug: string
      planLevel: number
      memberfulPlans: {
        memberfulPlan: MemberfulPlan
      }[]
    }
    displayName?: string
    description?: string
    badge?: string
    id: string
    name: string
    perks: TierPerk[]
    ctaLabel: string
    savingsLabel?: string | null
  }[]
  excludedPlatforms: ExcludedPlatforms
}
